const rejectedAuthAttempts = new Set();

export const buildRejectedAuthKey = ({ role, walletType, address }) =>
  `${walletType || "unknown"}:${String(address || "").toLowerCase()}:${role ?? ""}`;

export const rememberRejectedAuthAttempt = ({ role, walletType, address }) => {
  if (!address) {
    return;
  }
  rejectedAuthAttempts.add(buildRejectedAuthKey({ role, walletType, address }));
};

export const forgetRejectedAuthAttempt = ({ role, walletType, address } = {}) => {
  const targetRole = role ?? "";
  const targetWalletType = walletType || "unknown";
  if (!address) {
    for (const key of rejectedAuthAttempts) {
      if (key.startsWith(`${targetWalletType}:`) && key.endsWith(`:${targetRole}`)) {
        rejectedAuthAttempts.delete(key);
      }
    }
    return;
  }
  rejectedAuthAttempts.delete(buildRejectedAuthKey({ role, walletType, address }));
};

export const hasRejectedAuthAttempt = ({ role, walletType, address }) =>
  rejectedAuthAttempts.has(buildRejectedAuthKey({ role, walletType, address }));

